ceregoCommon.factory('ItemUploadResource', ['$resource', ($resource) ->
  $resource "",{},
    get:
      method: 'GET'
      isArray: false
      url: APIRoutes.v2_item_upload_path(":id")
      params:
        id: "@id"
])
